module.exports = __webpack_public_path__ + "static/media/CodeQuest-3.2820d601.jpeg";